import { Controller } from "@hotwired/stimulus";

const LEAP_YEAR_FALLBACK = 2000;

export default class extends Controller {
  static targets = ["dateField", "month", "day", "year"];

  connect() {
    this.syncDayOptions();
  }

  update() {
    this.syncDayOptions();
    this.dateFieldTarget.value = this.isoDate();
    this.yearTarget.setCustomValidity(
      this.incomplete() || this.isoDate() ? "" : "Enter a valid date"
    );
  }

  syncDayOptions() {
    const max = this.daysInMonth();
    for (const option of this.dayTarget.options) {
      option.hidden = Number(option.value) > max;
    }
    if (Number(this.dayTarget.value) > max) this.dayTarget.value = "";
  }

  daysInMonth() {
    if (!this.monthTarget.value) return 31;

    const year = Number(this.yearTarget.value) || LEAP_YEAR_FALLBACK;
    return new Date(year, Number(this.monthTarget.value), 0).getDate();
  }

  incomplete() {
    return (
      !this.monthTarget.value || !this.dayTarget.value || !this.yearTarget.value
    );
  }

  isoDate() {
    if (this.incomplete()) return "";

    const iso = `${this.yearTarget.value}-${this.monthTarget.value}-${this.dayTarget.value}`;
    return this.realDate(iso) ? iso : "";
  }

  realDate(iso) {
    const parsed = new Date(`${iso}T00:00:00`);
    return !isNaN(parsed) && parsed.getDate() === Number(this.dayTarget.value);
  }
}
